import type { Locale } from '../../i18n';

const RU = {
  'tab.status': 'Состояние обмена',
  'tab.discrepancies': 'Расхождения',
  'tab.runs': 'Прогоны миграции',
  'tab.export': 'Выгрузка',

  'common.refresh': 'Обновить',
  'common.loading': 'Загрузка…',
  'common.empty': 'Данных нет',
  'common.created': 'Создано',
  'common.status': 'Состояние',
  'common.entity': 'Сущность',

  'status.adapter': 'Источник',
  'status.available': 'Доступен',
  'status.unavailable': 'Недоступен',
  'status.readOnly': 'только чтение',
  'status.queue': 'В очереди',
  'status.failed': 'Не отправлено',
  'status.open': 'Открытых расхождений',
  'status.lastOk': 'Последняя удачная выгрузка',
  'status.never': 'не было',
  'status.resync': 'Выгрузить очередь',
  'status.truth': 'Источник истины по сущностям',
  'outbound.title': 'Исходящая очередь',
  'outbound.status.pending': 'В очереди',
  'outbound.status.failed': 'С ошибкой',
  'outbound.status.sent': 'Ушли',
  'outbound.status.all': 'Все',
  'outbound.entity': 'Запись',
  'outbound.op': 'Операция',
  'outbound.attempts': 'Попыток',
  'outbound.error': 'Последняя ошибка',
  'outbound.empty': 'В этом состоянии записей нет',

  'status.owner.platform': 'Платформа',
  'status.owner.legacy': 'Старая система',
  'status.hint': 'Недоступность старой системы копит очередь, но не останавливает обслуживание',

  'discrepancy.side': 'Сторона',
  'discrepancy.kind': 'Вид',
  'discrepancy.resolve': 'Разобрано',
  'discrepancy.none': 'Расхождений нет',

  'run.kind': 'Что переносим',
  'run.kind.customers': 'Клиенты',
  'run.kind.balances': 'Балансы',
  'run.kind.passes': 'Абонементы',
  'run.kind.feedback': 'Обращения',
  'run.status.draft': 'Черновик',
  'run.status.staged': 'Загружено',
  'run.status.dry_run': 'Пробный прогон',
  'run.status.validated': 'Сверено',
  'run.status.committed': 'Перенесено',
  'run.status.rolled_back': 'Откачено',
  'run.status.failed': 'Ошибка',
  'run.rows': 'Записей',
  'run.total': 'Сумма, ₸',
  'run.started': 'Начат',
  'run.dryRun': 'Пробный прогон',
  'run.validate': 'Сверить',
  'run.commit': 'Перенести',
  'run.rollback': 'Откатить',
  'run.source': 'Выгрузка (CSV или JSON)',
  'module.subtitle': 'Обмен со старой системой, разбор расхождений и перенос данных',
  'run.sourceHint':
    'CSV с колонками source_ref, phone, amount_minor. Без выгрузки прогон не начнётся: источник считается недоступным.',
  'run.sample': 'Подставить пример',
  'run.checksumBefore': 'Контрольная сумма до',
  'run.checksumAfter': 'Контрольная сумма после',
  'run.commitWarning': 'Перенос доступен только после сверки',

  'export.from': 'С',
  'export.to': 'По',
  'export.build': 'Сформировать',
  'export.orders': 'Заказов',
  'export.total': 'Сумма, ₸',
  'export.paid': 'Оплачено, ₸',
  'export.refunded': 'Возвращено, ₸',
  'export.csv': 'Скачать CSV',
  'status.notConfigured': 'Адаптер обмена не настроен: очередь копится и ничего не помечается отправленным',
  'status.delivered': 'Подтверждение',
  'inbound.title': 'Входящий обмен (изменения старой системы)',
  'inbound.entity': 'Сущность',
  'inbound.lastOk': 'Последняя загрузка',
  'inbound.error': 'Ошибка',
  'inbound.pull': 'Забрать изменения сейчас',
  'run.kindPick': 'Что переносим',
  'run.kind.history': 'История (визиты, заказы, платежи, бонусы)',
  'run.kind.catalog': 'Каталог',
  'run.hint.customers': 'CSV/JSON: source_ref, phone, name, plates (через |), email, visits, first_visit_at, last_visit_at',
  'run.hint.balances': 'CSV/JSON: source_ref, phone, amount (тенге) или amount_minor, expires_at, accrued_at, customer_ref, plate',
  'run.hint.passes': 'CSV/JSON: source_ref, phone, washes_left, value, valid_to',
  'run.hint.feedback': 'CSV/JSON: source_ref, received_at, channel, subject, body, resolution',
  'run.hint.history': 'CSV/JSON с колонкой type (visit, order, payment, bonus): source_ref, customer_ref, phone, plate, site, date, amount, method, parent_ref',
  'run.hint.catalog': 'CSV/JSON: code, name, price (тенге)',
  'run.report': 'Отчёт прогона',
  'quality.title': 'Пригодность данных',
  'quality.total': 'Записей',
  'quality.withPhone': 'С телефоном',
  'quality.withPlate': 'С номером авто',
  'quality.withBoth': 'С телефоном и номером',
  'quality.withHistory': 'С историей',
  'quality.withoutContact': 'Без контакта',
  'quality.duplicates': 'Повторы телефона',
  'plan.title': 'План переноса по строкам',
  'plan.pending': 'Ждут решения',
  'plan.transfer': 'К переносу',
  'plan.createProfiles': 'Новых профилей',
  'plan.writtenOff': 'Списано с основанием',
  'plan.staged': 'Сумма выгрузки',
  'plan.reason': 'Причина',
  'plan.customerId': 'ID клиента',
  'plan.amount': 'Сумма, ₸',
  'plan.comment': 'Основание',
  'plan.assign': 'Назначить клиенту',
  'plan.writeOff': 'Списать',
  'plan.none': 'Все строки разнесены — можно сверять',
  'reason.no_contact': 'Нет телефона, номера и ссылки на клиента',
  'reason.amount_unparsed': 'Сумма не разобрана',
  'reason.negative_amount': 'Отрицательный баланс',
  'reason.conflict': 'Телефон и номер указывают на разных клиентов',
  'reason.duplicate_of_unresolved': 'Повтор строки, которая ждёт решения',
  'reason.customer_ref_not_found': 'Клиент старой базы не найден',
  'reason.amount_required': 'Укажите сумму',
  'reason.not_matched': 'Сначала пробный прогон',
  'export.onecCsv': '1С: реестр операций',
  'export.commerceml': '1С: CommerceML (реализация)',
  'export.subscription': 'Абонентская плата, ₸',
  'export.net': 'Итого, ₸',
  'export.byOperation': 'Период считается по дате операции: оплата — днём оплаты, возврат — днём возврата.',
  'open.title': 'Выгрузка в открытом формате',
  'open.hint': 'Колонки совпадают с загрузкой: файл можно загрузить обратно без переделки.',
  'open.entity': 'Данные',
} as const;

const KK: Record<keyof typeof RU, string> = {
  'tab.status': 'Алмасу күйі',
  'tab.discrepancies': 'Алшақтықтар',
  'tab.runs': 'Көші-қон жүрістері',
  'tab.export': 'Түсіру',

  'common.refresh': 'Жаңарту',
  'common.loading': 'Жүктелуде…',
  'common.empty': 'Дерек жоқ',
  'common.created': 'Жасалды',
  'common.status': 'Күйі',
  'common.entity': 'Мәні',

  'status.adapter': 'Дереккөз',
  'status.available': 'Қолжетімді',
  'status.unavailable': 'Қолжетімсіз',
  'status.readOnly': 'тек оқу',
  'status.queue': 'Кезекте',
  'status.failed': 'Жіберілмеген',
  'status.open': 'Ашық алшақтықтар',
  'status.lastOk': 'Соңғы сәтті түсіру',
  'status.never': 'болған жоқ',
  'status.resync': 'Кезекті жіберу',
  'status.truth': 'Мәндер бойынша ақиқат көзі',
  'outbound.title': 'Шығыс кезек',
  'outbound.status.pending': 'Кезекте',
  'outbound.status.failed': 'Қатемен',
  'outbound.status.sent': 'Жіберілді',
  'outbound.status.all': 'Барлығы',
  'outbound.entity': 'Жазба',
  'outbound.op': 'Операция',
  'outbound.attempts': 'Әрекет',
  'outbound.error': 'Соңғы қате',
  'outbound.empty': 'Бұл күйде жазбалар жоқ',

  'status.owner.platform': 'Платформа',
  'status.owner.legacy': 'Ескі жүйе',
  'status.hint': 'Ескі жүйенің қолжетімсіздігі кезекті жинайды, бірақ қызмет көрсетуді тоқтатпайды',

  'discrepancy.side': 'Тарап',
  'discrepancy.kind': 'Түрі',
  'discrepancy.resolve': 'Шешілді',
  'discrepancy.none': 'Алшақтық жоқ',

  'run.kind': 'Не көшіреміз',
  'run.kind.customers': 'Клиенттер',
  'run.kind.balances': 'Баланстар',
  'run.kind.passes': 'Абонементтер',
  'run.kind.feedback': 'Өтініштер',
  'run.status.draft': 'Жоба',
  'run.status.staged': 'Жүктелді',
  'run.status.dry_run': 'Сынақ жүріс',
  'run.status.validated': 'Салыстырылды',
  'run.status.committed': 'Көшірілді',
  'run.status.rolled_back': 'Кері қайтарылды',
  'run.status.failed': 'Қате',
  'run.rows': 'Жазба',
  'run.total': 'Сома, ₸',
  'run.started': 'Басталды',
  'run.dryRun': 'Сынақ жүріс',
  'run.validate': 'Салыстыру',
  'run.commit': 'Көшіру',
  'run.rollback': 'Кері қайтару',
  'run.source': 'Түсіру (CSV немесе JSON)',
  'module.subtitle': 'Ескі жүйемен алмасу, айырмашылықтарды талдау және деректерді көшіру',
  'run.sourceHint':
    'source_ref, phone, amount_minor бағандары бар CSV. Выгрузкасыз прогон басталмайды.',
  'run.sample': 'Мысал қою',
  'run.checksumBefore': 'Дейінгі бақылау сомасы',
  'run.checksumAfter': 'Кейінгі бақылау сомасы',
  'run.commitWarning': 'Көшіру тек салыстырудан кейін қолжетімді',

  'export.from': 'Бастап',
  'export.to': 'Дейін',
  'export.build': 'Қалыптастыру',
  'export.orders': 'Тапсырыс',
  'export.total': 'Сома, ₸',
  'export.paid': 'Төленді, ₸',
  'export.refunded': 'Қайтарылды, ₸',
  'export.csv': 'CSV жүктеу',
  'status.notConfigured': 'Алмасу адаптері бапталмаған: кезек жиналады, ештеңе жіберілген деп белгіленбейді',
  'status.delivered': 'Растау',
  'inbound.title': 'Кіріс алмасу (ескі жүйенің өзгерістері)',
  'inbound.entity': 'Мәні',
  'inbound.lastOk': 'Соңғы жүктеу',
  'inbound.error': 'Қате',
  'inbound.pull': 'Өзгерістерді қазір алу',
  'run.kindPick': 'Не көшіреміз',
  'run.kind.history': 'Тарих (келулер, тапсырыстар, төлемдер, бонустар)',
  'run.kind.catalog': 'Каталог',
  'run.hint.customers': 'CSV/JSON: source_ref, phone, name, plates (| арқылы), email, visits, first_visit_at, last_visit_at',
  'run.hint.balances': 'CSV/JSON: source_ref, phone, amount (теңге) немесе amount_minor, expires_at, accrued_at, customer_ref, plate',
  'run.hint.passes': 'CSV/JSON: source_ref, phone, washes_left, value, valid_to',
  'run.hint.feedback': 'CSV/JSON: source_ref, received_at, channel, subject, body, resolution',
  'run.hint.history': 'type бағаны бар CSV/JSON (visit, order, payment, bonus): source_ref, customer_ref, phone, plate, site, date, amount, method, parent_ref',
  'run.hint.catalog': 'CSV/JSON: code, name, price (теңге)',
  'run.report': 'Жүріс есебі',
  'quality.title': 'Деректердің жарамдылығы',
  'quality.total': 'Жазбалар',
  'quality.withPhone': 'Телефонымен',
  'quality.withPlate': 'Көлік нөмірімен',
  'quality.withBoth': 'Телефон және нөмір',
  'quality.withHistory': 'Тарихымен',
  'quality.withoutContact': 'Байланыссыз',
  'quality.duplicates': 'Телефон қайталануы',
  'plan.title': 'Жолдар бойынша көшіру жоспары',
  'plan.pending': 'Шешім күтеді',
  'plan.transfer': 'Көшіруге',
  'plan.createProfiles': 'Жаңа профильдер',
  'plan.writtenOff': 'Негізбен есептен шығарылды',
  'plan.staged': 'Түсіру сомасы',
  'plan.reason': 'Себеп',
  'plan.customerId': 'Клиент ID',
  'plan.amount': 'Сома, ₸',
  'plan.comment': 'Негіз',
  'plan.assign': 'Клиентке тағайындау',
  'plan.writeOff': 'Есептен шығару',
  'plan.none': 'Барлық жолдар бөлінді — салыстыруға болады',
  'reason.no_contact': 'Телефон, нөмір және клиент сілтемесі жоқ',
  'reason.amount_unparsed': 'Сома талданбады',
  'reason.negative_amount': 'Теріс баланс',
  'reason.conflict': 'Телефон мен нөмір әртүрлі клиенттерді көрсетеді',
  'reason.duplicate_of_unresolved': 'Шешім күтетін жолдың қайталануы',
  'reason.customer_ref_not_found': 'Ескі базаның клиенті табылмады',
  'reason.amount_required': 'Соманы көрсетіңіз',
  'reason.not_matched': 'Алдымен сынақ жүрісі',
  'export.onecCsv': '1С: операциялар тізілімі',
  'export.commerceml': '1С: CommerceML (өткізу)',
  'export.subscription': 'Абоненттік төлем, ₸',
  'export.net': 'Барлығы, ₸',
  'export.byOperation': 'Кезең операция күні бойынша есептеледі: төлем — төлем күні, қайтару — қайтару күні.',
  'open.title': 'Ашық форматта түсіру',
  'open.hint': 'Бағандар жүктеумен сәйкес: файлды өзгертпей кері жүктеуге болады.',
  'open.entity': 'Деректер',
};

export type BridgeKey = keyof typeof RU;
export type BridgeTranslate = (key: BridgeKey) => string;

export function makeBridgeT(locale: Locale): BridgeTranslate {
  const dict: Record<string, string> = locale === 'kk' ? KK : RU;
  return (key) => dict[key] ?? key;
}

export function money(minor: number): string {
  return (minor / 100).toLocaleString('ru-RU', { maximumFractionDigits: 2 });
}
